import { createIcon } from '../createIcon';
import { ReactComponent as IconEdit } from '../svg/edit.svg';

export default createIcon(IconEdit);
